export type IStatusIcon = "success" | "error" | "warning";

export const RenderStatusIcon = ({ icon, size }: { icon: IStatusIcon; size: number }) => {
  return (
    <img alt="icon" src={`/assets/icons/icon-${icon}.png`} width={size / 3} height={size / 3} />
  );
};
